import { marked } from 'marked'
import DOMPurify from 'dompurify'

// GFM (tables, autolinks) on; soft line breaks become <br>.
marked.setOptions({ gfm: true, breaks: true })

export function renderMarkdown(src) {
  const parsed = marked.parse(src || '')
  if (typeof window !== 'undefined' && DOMPurify && typeof DOMPurify.sanitize === 'function') {
    return DOMPurify.sanitize(parsed)
  }
  return parsed
}

